import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  IGetawayBookInfo,
  GetawaysLocationEnum,
  GetawaysCondoSubCategoryEnum,
  ICustomGetawaysListHeaderInfo,
} from 'src/common-types/index';
import GetawaysCruise from 'src/assets/images/getaways/getaways-cruise.png';
import GetawaysFantasy from 'src/assets/images/getaways/getaways-fantasy.png';
import GetawaysCondoValue from 'src/assets/images/getaways/getaways-condo-value.png';
import GetawaysCondoPremium from 'src/assets/images/getaways/getaways-condo-premium.png';
import GetawaysStaycations from 'src/assets/images/getaways/getaways-staycations.png';

export const updateGetawayBookInfo = (
  infoObject: IGetawayBookInfo,
  value: { [key: string]: string | number | boolean },
): IGetawayBookInfo => {
  const newInfo = {
    ...infoObject,
    ...value,
  };
  return newInfo;
};

export const renderGetawayListHeaderInfo = (
  specialTypeName: string,
): ICustomGetawaysListHeaderInfo => {
  switch (specialTypeName) {
    case GetawaysCondoSubCategoryEnum.PremierEscapes: {
      return {
        headerImg: GetawaysCondoPremium,
        headerTitle: 'getaways.condo.premium.title',
        headerSubtitle: 'getaways.condo.premium.text',
      };
    }
    case GetawaysCondoSubCategoryEnum.ValueGetaways: {
      return {
        headerImg: GetawaysCondoValue,
        headerTitle: 'getaways.condo.value.title',
        headerSubtitle: 'getaways.condo.value.text',
      };
    }
    case GetawaysLocationEnum.Fantasy: {
      return {
        headerImg: GetawaysFantasy,
        headerTitle: 'getaway.fantasy.title',
        headerSubtitle: 'getaway.fantasy.subtitle',
      };
    }
    case GetawaysLocationEnum.Cruise: {
      return {
        headerImg: GetawaysCruise,
        headerTitle: 'getaway.cruise.title',
        headerSubtitle: 'getaway.cruise.subtitle',
      };
    }
    case GetawaysLocationEnum.Staycation: {
      return {
        headerImg: GetawaysStaycations,
        headerTitle: 'getaway.staycations.custom.title',
        headerSubtitle: 'getaway.staycations.subtitle',
      };
    }
    default:
      return null;
  }
};

export const renderPriceBasedOn = (
  specialTypeName: string,
  isDetails: boolean,
): React.ReactNode => {
  switch (specialTypeName) {
    case GetawaysLocationEnum.Fantasy:
    case GetawaysLocationEnum.Cruise: {
      return <FormattedMessage id="per.person" />;
    }
    case GetawaysLocationEnum.Staycation: {
      return <FormattedMessage id={`${isDetails ? 'total.to.pay' : 'per.night'}`} />;
    }
    case GetawaysLocationEnum.Condo: {
      return <FormattedMessage id="per.week" />;
    }
    default:
      return null;
  }
};

export const renderGetawaysCardDate = (
  specialTypeName: string,
  formattedDate: string,
  staycationDate: string,
  lengthOfStay: string,
  city: string,
  numberOfNights: number,
  state: string,
): React.ReactNode => {
  switch (specialTypeName) {
    case GetawaysLocationEnum.Fantasy: {
      return <span>{lengthOfStay}</span>;
    }
    case GetawaysLocationEnum.Cruise: {
      return (
        <span>
          <FormattedMessage id="nights" values={{ count: numberOfNights }} />{!formattedDate ? '' : ', ' + formattedDate}
        </span>
      );
    }
    case GetawaysLocationEnum.Staycation: {
      return (
        <span>
          {city}, {state}, {staycationDate}
        </span>
      );
    }
    case GetawaysLocationEnum.Condo: {
      return <span>{formattedDate}</span>;
    }
    default:
      return null;
  }
};

export const renderGetawaysDetailsTitle = (specialTypeName: string): React.ReactNode => {
  switch (specialTypeName) {
    case GetawaysLocationEnum.Fantasy: {
      return <FormattedMessage id="getaways.details.fantasy" />;
    }
    case GetawaysLocationEnum.Cruise: {
      return <FormattedMessage id="getaways.details.cruise" />;
    }
    case GetawaysLocationEnum.Staycation: {
      return <FormattedMessage id="getaways.details.staycation" />;
    }
    case GetawaysLocationEnum.Condo: {
      return <FormattedMessage id="getaways.details.condo" />;
    }
    default:
      return null;
  }
};

export const GETAWAY_BACKGROUND_TRANSPARENT = 'rgba(32, 39, 77, 0.2)';
